module.exports = __webpack_public_path__ + "src/assets/img/customer-logos/zymergen.77cc6a60e269d59ef4b809f174929ff2.png";